/* eslint-disable import/prefer-default-export */
export const NBRSP = '\xa0'
